//import react this will hopefully show up on the right side
import React from "react";

function Author({ className }) {
  return (
    <div className={className}>
      <p>
        Designed By <strong>Riley Costello</strong>
      </p>
    </div>
  );
}

export default Author;
